import styled from 'styled-components';
import { Card } from 'antd';

export const LoginCard = styled(Card)`
  .ant-card-body {
    background-color: #ffffff !important;
  }
    .ant-input{
        background-color: #ffffff !important;
        color: #000000d9 !important;
    }
`;